import React, { lazy, Suspense } from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import BannerOne from "../components/BannerOne";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";


const FeatureOne     = lazy(() => import("../components/FeatureOne"));
const Banner         = lazy(() => import("../components/Banner"));
const NewArrivalOne  = lazy(() => import("../components/NewArrivalOne"));
const RecommendedOne = lazy(() => import("../components/RecommendedOne"));
const Banner2        = lazy(() => import("../components/Banner2"));
const HotDealsOne    = lazy(() => import("../components/HotDealsOne"));
const ShippingOne    = lazy(() => import("../components/ShippingOne"));
const FooterOne      = lazy(() => import("../components/FooterOne"));
const BottomFooter   = lazy(() => import("../components/BottomFooter"));

// ── Simple skeleton placeholder ──
const SectionSkeleton = ({ height = "200px" }) => (
  <div style={{
    width: "100%",
    height,
    background: "linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.4s infinite",
    borderRadius: "8px",
    margin: "8px 0",
  }}>
    <style>{`
      @keyframes shimmer {
        0%   { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
    `}</style>
  </div>
);

const HomePageOne = () => {
  return (
    <>
   
      <Preloader />
      <ScrollToTop smooth color="#299E60" />
      <ColorInit color={false} />
      <HeaderOne />
      <BannerOne />

      <Suspense fallback={<SectionSkeleton height="220px" />}>
        <FeatureOne />
      </Suspense>

      <Suspense fallback={<SectionSkeleton height="180px" />}>
        <Banner />
      </Suspense>

      <Suspense fallback={<SectionSkeleton height="380px" />}>
        <NewArrivalOne />
      </Suspense>

      <Suspense fallback={<SectionSkeleton height="380px" />}>
        <RecommendedOne />
      </Suspense>

      <Suspense fallback={<SectionSkeleton height="180px" />}>
        <Banner2 />
      </Suspense>

      <Suspense fallback={<SectionSkeleton height="380px" />}>
        <HotDealsOne />
      </Suspense>

      <Suspense fallback={<SectionSkeleton height="160px" />}>
        <ShippingOne />
      </Suspense>

      <Suspense fallback={<SectionSkeleton height="300px" />}>
        <FooterOne />
      </Suspense>

      <Suspense fallback={<SectionSkeleton height="60px" />}>
        <BottomFooter />
      </Suspense>
    </>
  );
};

export default HomePageOne;